module.exports = __webpack_public_path__ + "static/media/home-wood-1.a8ee265c.jpg";